import { combineReducers } from 'redux'
import { reducer as form } from 'redux-form'
import registry, * as fromRegistry from 'registry/reducers/registry-reducer'
import user from 'registry/reducers/user-reducer'
import onboarding from 'registry/modules/onboarding/reducers/onboarding-reducer'

export default combineReducers({
  form,
  onboarding,
  registry,
  user,
})

export const getOnboarding = (state) => state.onboarding
export const getRegistry = (state) => state.registry
export const getUser = (state) => state.user
export const getArrivalDate = (state) =>
  fromRegistry.getArrivalDate(getRegistry(state))
export const getPlanningStage = (state) =>
  fromRegistry.getPlanningStage(getRegistry(state))
